/**
 *
 * Project settings - override any values from platform settingsDefaults here
 *
 */

import settingsDefault from '_platform/src/theme/settingsDefault';

const settings = {
  // -- Base Settings --
  siteName: 'Ream Rewards',

  // -- Cloudinary Settings --
  // Cloudinary cloud name
  cloudinaryCloudName: 'incremental',

  // -- Rewards --
  // Hide reward category images (main rewards page)
  // rewardsCategoryHideImage: true,

  // Pages - must have trailing slash
  cartPage: '/cart/',
  privacyPage: '/privacy/',
  rewardsPage: '/rewards/',

  // Delivery method "Client" label (usually Branch or Rep)
  deliveryMethodClientLabel: 'Rep',

  // Master override settings
  // cartDisabled: true,
  // quickviewDisabled: true,
  // wishlistDisabled: true,

  // -- Default Overrides --

  loginRememberMeEnabled: false,

  // Mobile App SSO
  mobileAppSSOEnabled: true,

  // Important!: If the user is being redirected, ensure that the PrivateRoute
  // component has the `tempAuthAllowed` prop set, otherwise the user will not
  // be able to see/update their profile.
  // For futher documentation, see _platform/src/theme/settingsDefault.js
  // redirectOnIncompleteProfile: '/profile/',

  // Rewards page - disable category listing and display rewards on the main page
  // rewardsCategorySkip: true,

  // Google Maps JavaScript API URL
  // Instructions: https://developers.google.com/maps/documentation/javascript/get-api-key
  // Create the project and generate the Maps Javascript API key in
  // https://console.cloud.google.com/google/maps-apis/apis/places-backend.googleapis.com/
  // Make sure the following APIs are enabled:
  // - Maps JavaScript API
  // - Places API
  // - Geocoding API
  // Make sure to restrict the API Key to prevent unauthorised use - Restrict to used services.
  // Lori-dev key: AIzaSyD23PltrHxEzGeDPgqoqsUkZwz_fKb6sic
};

// Note: If you are altering the breakpoints, make sure you loop over the
// values and create the media prop. See settingsDefault.js for implementation.

// Deep merge with default values
const settingsApp = { ...settingsDefault, ...settings };

export default settingsApp;
